import { render } from "./IssuePayment.vue?vue&type=template&id=f0cc7b12&ts=true"
import script from "./IssuePayment.vue?vue&type=script&lang=ts"
export * from "./IssuePayment.vue?vue&type=script&lang=ts"

import "./IssuePayment.vue?vue&type=style&index=0&id=f0cc7b12&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__